import { defineStore } from 'pinia';
import { useAPI } from '~/composables/useAPI';

export const useProductosStore = defineStore('productos', {
    state: () => ({
        destacados: {
            P:[],
            M:[],
            L:[],
            C:[],
        },
        atributos: null,
        current: null,
        _fetchToken: 0,
        filtro:{
            gama:[],
            serie:[],
            modelo:[],
            acabado:[],
            decoracion:[],
            vidrio:[],
        },
        seleccionados :{
            gama:[],
            serie:[],
            modelo:[],
            acabado:[],
            decoracion:[],
            vidrio:[],
        },
        productos:[],
        producto:null,
        page: 1

    }),
    actions: {
        async fetchDestacados(gama) {
            const api = useAPI();
            const response = await api.get(`productos/destacados/${gama}`);
            switch (gama) {
                case "P":
                    this.destacados.P = response.data;
                    break;
                case "M":
                    this.destacados.M = response.data;
                    break;
                case "L":
                    this.destacados.L = response.data;
                    break;
                case "C":
                    this.destacados.C = response.data;
                    break;

                default:

            }

        },
        async fetchAtributos(filtro) {
            const token = ++this._fetchToken;
            this.current = { ...filtro };
            this.page = 1;
            this.productos = [];
            const api = useAPI();

            const [filtroRes, atributosRes] = await Promise.all([
                api.get('productos/atributos/filtro', filtro),
                api.get('productos/atributos'),
            ]);

            if (token !== this._fetchToken) return;

            const resultado = filtroRes.data.reduce((acc, item) => {
                const tipo = item.atributo_tipo;
                if (!acc[tipo]) acc[tipo] = [];
                acc[tipo].push(item.id);
                return acc;
            }, {});
            this.seleccionados.serie = resultado.SERIE ?? [];
            this.seleccionados.gama = resultado.GAMA ?? [];
            this.seleccionados.modelo = resultado.MODELO ?? [];
            this.seleccionados.acabado = resultado.ACABADO ?? [];
            this.seleccionados.decoracion = resultado.DECORACION ?? [];
            this.seleccionados.vidrio = resultado.VIDRIO ?? [];

            this.atributos = atributosRes.data;
            this.filtro.serie = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "SERIE");
            this.filtro.gama = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "GAMA");
            this.filtro.modelo = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "MODELO");
            this.filtro.acabado = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "ACABADO");
            this.filtro.decoracion = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "DECORACION");
            this.filtro.vidrio = Object.values(atributosRes.data).filter(item => item.atributo_tipo === "VIDRIO");

            await this.fetchProductos();
        },
        async fetchFiltro(filtro) {
            const api = useAPI();
            const response = await api.get('productos/atributos/filtro', filtro);

            const resultado = response.data.reduce((acc, item) => {
                const tipo = item.atributo_tipo;
                if (!acc[tipo]) acc[tipo] = [];
                acc[tipo].push(item.id);
                return acc;
            }, {});

            this.seleccionados.serie = resultado.SERIE ?? []
            this.seleccionados.gama = resultado.GAMA ?? []
            this.seleccionados.modelo = resultado.MODELO ?? []
            this.seleccionados.acabado = resultado.ACABADO ?? []
            this.seleccionados.decoracion = resultado.DECORACION ?? []
            this.seleccionados.vidrio = resultado.VIDRIO ?? []
        },
        async fetchProductos(filtro) {
            if (!this.current) return;
            const api = useAPI();
            this.current.page = this.page
            const response = await api.get('productos/resultados', this.current);
            if (this.page == 1)
            {

                this.productos = response.data;
            }
            else {
                this.productos = this.productos.concat(...response.data);
            }
            this.page = this.page+1
        },


        async fetchProducto(id) {
            const api = useAPI();
            this.current.page = this.page
            const response = await api.get(`productos/${id}`);
            this.producto = response.data;
        },

    },
});
